const Menu = [
    {
        name: 'Inicio',
        path: '/inicio',
        icon : 'icon-grid',
        translate: 'sidebar.nav.INICIO'
    },
    {
        name: 'Usuarios TRIAL',
        path: '/usuariostrial',
        icon : 'fas fa-child',
        translate: 'sidebar.nav.USUARIOSTRIAL'
    },
    {
        name: 'Prospectos',
        path: '/prospectos',
        icon : 'fab fa-creative-commons-by',
        translate: 'sidebar.nav.PROSPECTOS'
    },
    {
        name: 'CMS demostrativo',
        href: true,//"http://plataforman035.trascenti.com/login-consultor?" + btoa(47 + "-" + sessionStorage.getItem('iIDConsultor') ),//no tomar en cuenta, error
        path: '/cms',
        icon : 'fa fa-desktop',
        translate: 'sidebar.nav.CMS'
    },
    {
        name: 'Empresas',
        path: '/clientes',
        icon : 'fas fa-users',
        translate: 'sidebar.nav.CLIENTES'
    },
    {
        name: 'Consultores',
        path: '/consultores',
        icon : 'fas fa-user-tie',
        translate: 'sidebar.nav.CONSULTORES'
    },
    {
        name: 'Centro de mensajes',
        path: '/centro-mensajes',
        icon : 'fas fa-envelope',
        translate: 'sidebar.nav.CENTROMENSAJES'
    },
    {
        name: 'Soporte técnico',
        path: '/soporte',
        icon : 'fab fa-whmcs',
        translate: 'sidebar.nav.SOPORTE'
    },
    {
        name: 'Cerrar sesión',
        path: '/login',
        icon : 'fas fa-sign-out-alt',
        translate: 'sidebar.nav.CERRARSESION'
    }
    /*{
        name: 'Menu',
        icon: 'icon-speedometer',
        translate: 'sidebar.nav.MENU',
        label: { value: 1, color: 'info' },
        submenu: [{
            name: 'Submenu',
            translate: 'sidebar.nav.SUBMENU',
            path: 'submenu'
        }]
    }*/
];

export default Menu;
